import { Form } from "./Components/Form";

import "jquery";
import "bootstrap";
import "admin-lte";
import "sweetalert2";
// import "jquery-blockui";

import "./vistas/dist/css/my_style.css"; 
import "./vistas/plugins/fontawesome-free/css/all.min.css";
import "./vistas/dist/css/adminlte.css";
import "./App.css";


function App() {
  return <Form />;
}

export default App;
